import * as React from 'react'
import { PaymentNudge } from '../payment-nudge'
import { useUserPromoPopupData } from './use-user-promo-data'
import { PromoPopupLoggedInTrial } from './types/logged-in-trial-banner'
import { PromoPopupLoggedInYearly } from './types/logged-in-yearly-banner'
import { PromoPopupLoggedInUnsubscribed } from './types/logged-in-unsubscribed-banner'
import { shouldShowPopup } from './utils'
import { FREE_TRIAL_ELIGIBLE_AGAIN_SEARCH_PARAM } from 'constants/search-params'

export function PromoPopups() {
  const [isOpen, setIsOpen] = React.useState(false)
  const { loggedInUnsubscribedPromo, loggedInTrialPromo, loggedInYearlyPromo, stripeCustomerId } =
    useUserPromoPopupData()

  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href)
    if (url.searchParams.get(FREE_TRIAL_ELIGIBLE_AGAIN_SEARCH_PARAM) === 'true') {
      return null
    }
  }

  if (shouldShowPopup('LOGGED_IN_UNSUBSCRIBED') && loggedInUnsubscribedPromo) {
    return <PromoPopupLoggedInUnsubscribed isOpen={isOpen} setIsOpen={setIsOpen} />
  }

  if (shouldShowPopup('LOGGED_IN_TRIAL') && loggedInTrialPromo) {
    return (
      <PromoPopupLoggedInTrial
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        stripeCustomerId={stripeCustomerId}
      />
    )
  }

  if (shouldShowPopup('LOGGED_IN_YEARLY') && loggedInYearlyPromo) {
    return (
      <PromoPopupLoggedInYearly
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        stripeCustomerId={stripeCustomerId}
      />
    )
  }

  return <PaymentNudge />
}
